<template lang="pug">
.alert.alert-warning(v-if="err") {{err.message}}
div.has-fixed-footer(v-else)
    .card(v-for="person in filteredPeople").mb-2
        .card-header
            router-link(:to="'/people/' + person.id")
                h5.card-title {{person.first_name}} {{person.last_name}}
                h6.card-subtitle.text-muted {{person.email}}
    .alert.alert-light(v-if="filteredPeople.length === 0")
        | No people are defined for this biobank.
    .page-action-footer
        .container
            router-link.btn.btn-success(to="/person-new") Add Person
</template>

<script>
import {getPeople} from "../api";
import {filteredPeople} from "./common";

export default {
    data() {
        return {
            err: null,
            people: []
        }
    },
    created() {
        this.loadPeople();
    },
    methods: {
        loadPeople() {
            const biobank = localStorage.getItem("biobank") || "";
            const request = biobank ? getPeople({biobank}) : getPeople();
            request
                .then(people => {
                    this.err = null;
                    this.people = people;
                })
                .catch(err => this.err = err);
        }
    },
    watch: {
        $route() {
            this.loadPeople();
        }
    },
    computed: { filteredPeople }
}
</script>
